import i18n from 'i18next'

export const numVisitors = [
    { value: 250, label: 'Less than 500' },
    { value: 500, label: '500 - 1,000' },
    { value: 1500, label: '1,000 - 2,000' },
    { value: 2500, label: '2,000 - 3,000' },
    { value: 4000, label: '3,000 - 5,000' },
    { value: 6250, label: '5,000 - 7,500' },
    { value: 8750, label: '7,500 - 10,000' },
    { value: 12500, label: '10,000 - 15,000' },
    { value: 20000, label: '15,000 - 25,000' },
    { value: 37500, label: '25,000 - 50,000' },
    { value: 75000, label: '50,000 - 100,000' },
    { value: 100000, label: 'More than 100,000' },
]

export const numExhibitors = [
    { value: 5, label: 'Less than 10' },
    { value: 18, label: '10 - 25' },
    { value: 38, label: '26 - 50' },
    { value: 75, label: '51 - 100' },
    { value: 150, label: '101 - 200' },
    { value: 250, label: '201 - 300' },
    { value: 350, label: '301 - 400' },
    { value: 450, label: '401 - 500' },
    { value: 750, label: '501 - 1000' },
    { value: 1000, label: 'More than 1000' },
]

export const templateLicenceTypes = () => ([
    {
        value: 'ALL',
        label: i18n.t('all'),
    },
    {
        value: 'R',
        label: i18n.t('template.licence.type.R'),
    },
    {
        value: 'PE',
        label: i18n.t('template.licence.type.PE'),
    },
])
